import { ellipsis } from "./ellipsis";
import { formatMessage } from "lib/globalize-util";
import {
    removeAssortmentExtRegex,
    removeRollupExtRegex,
    removeShortcutExtRegex,
    removeWhiteboardExtRegex,
} from "containers/folders/hooks/utils";
import { ItemKind } from "../types/base";
import moment from "moment";

export const nameExtRemover = (name: string, kind: ItemKind) => {
    let nameWithoutExtension;
    switch (kind) {
        case ItemKind.CollectionDocument:
            const [, assortmentName] = name?.match(removeAssortmentExtRegex) || [];
            nameWithoutExtension = assortmentName || name;
            break;
        case ItemKind.BoardDocument:
            const [, whiteboardName] = name?.match(removeWhiteboardExtRegex) || [];
            nameWithoutExtension = whiteboardName || name;
            break;
        case ItemKind.Shortcut:
            const [, shortcutName] = name?.match(removeShortcutExtRegex) || [];
            nameWithoutExtension = shortcutName || name;
            break;
        case ItemKind.Folder:
            const [, rollupName] = name?.match(removeRollupExtRegex) || [];
            nameWithoutExtension = rollupName || name;
            break;
        default:
            nameWithoutExtension = name;
            break;
    }
    return nameWithoutExtension;
};

export const generateShortcutName = ({
    item,
    includeMilliseconds,
    shouldIncludeDateFormat,
}: {
    item: Partial<nuorder.folder.v1.Item>;
    includeMilliseconds?: boolean;
    shouldIncludeDateFormat?: boolean;
}) => {
    const nameSections = [];
    const initialMaxLength = 94; // MAX_LENGTH_DATABASE(100) - "`.short` extension(6)";
    const name = nameExtRemover(item?.name || "", item?.kind as ItemKind);
    const prefixText = "Shortcut to ";
    const dateWithCustomFormat = moment().format(
        includeMilliseconds ? "YYYY-MMM-DD HH-mm-ss-SSS" : "YYYY-MMM-DD HH-mm",
    );

    if (shouldIncludeDateFormat) {
        nameSections.push(
            formatMessage(`${prefixText}|name|`, {
                name: ellipsis(name, {
                    char: "",
                    maxLength: initialMaxLength - (prefixText.length + (dateWithCustomFormat.length + 1)), // 1 is the value for the space between the target name and the date added by join(" ") in the return
                }),
            }),
        );
        nameSections.push(dateWithCustomFormat);
    } else {
        nameSections.push(
            formatMessage(`${prefixText}|name|`, {
                name: ellipsis(name, {
                    char: "",
                    maxLength: initialMaxLength - prefixText.length,
                }),
            }),
        );
    }

    return nameSections.filter((it) => !!it).join(" ");
};
